import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { SCREEN_NAME, CLICK_ACTIONS } from "@cart-client/analytics/constants";

export const clickInfoIcon = (
    cartId: string,
    context: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_INFO_ICON,
        label: cartId,
        context: context,
    });
};
